// Topological sort over the DRG.
//
// A decision depends on its informationRequirements (inputs + upstream
// decisions) AND its knowledgeRequirements (BKMs it invokes). BKMs may in
// turn depend on other BKMs via knowledgeRequirements. InputData is a leaf.
//
// Returns IDs in dependency-first order. Throws on cycles.

export class TopoSortError extends Error {
  constructor(msg) { super(`[simulator/topo] ${msg}`); }
}

export function topoSort(drgElements) {
  const byId = new Map(drgElements.map((el) => [el.id, el]));
  const order = [];
  const state = new Map(); // id → 'visiting' | 'done'

  function visit(id, stack) {
    const el = byId.get(id);
    if (!el) return; // dangling requirement — skip silently
    const s = state.get(id);
    if (s === 'done') return;
    if (s === 'visiting') {
      throw new TopoSortError(`cycle detected at '${id}' (stack: ${[...stack, id].join(' → ')})`);
    }
    state.set(id, 'visiting');
    (el.requirements || []).forEach((req) => {
      if (req.sourceRef) visit(req.sourceRef, [...stack, id]);
    });
    state.set(id, 'done');
    order.push(id);
  }

  drgElements.forEach((el) => visit(el.id, []));
  return order;
}
